<template>
  <Loader :value="promises.fetch" :message="$metaInfo.title" class="product-review">
    <div class="container view">
      <HeaderComponent :title="$metaInfo.title" :breadcrumb="breadcrumbs"></HeaderComponent>
      <div class="product-review__complete" v-if="!data || !data.id">
        <FontAwesomeIcon :icon="['fas', 'check-circle']" />
      </div>
      <div v-else>
        <Alert class="product-review__alert"> {{ $t('productReviewAlert') }}. </Alert>
        <ProductForm v-if="data && data.id" v-model="data" @submit="submit" ref="form" :disabledFields="disabledFields">
          <template #footer="{ validator }">
            <section class="product-review__footer">
              <div class="product-review__buttons">
                <div v-if="products.length">
                  <ButtonComponent
                    :label="$t('reviewSkip')"
                    type="button"
                    :icon="['fal', 'angle-right']"
                    @click="skip"
                  />
                  <div class="product-review__status">{{ $t('productsInReview') }}: {{ products.length + 1 }}</div>
                </div>
                <div>
                  <ButtonComponent
                    :label="$t('saveAndContinue')"
                    theme="primary"
                    type="submit"
                    :disabled="validator && !validator.passes"
                    :icon="['fal', 'arrow-to-right']"
                    :promise="promises.submit"
                  />
                  <div class="product-review__status">
                    {{ $t('lastUpdated') }} {{ data.updatedAt | Moment('DD. MMM YYYY') }}
                  </div>
                </div>
              </div>
            </section>
          </template>
        </ProductForm>
      </div>
    </div>
  </Loader>
</template>

<script>
import { Moment } from '@/filters'
import ModelMixin from '@/mixins/Model'
import Model from '@/models/Product'

import HeaderComponent from '@/components/Header'
import Card from '@/components/Card'
import ProductForm from '@/components/Product/Form'
import Query from '@/api/graphql/queries/Products.gql'
import Mutate from '@/api/graphql/mutations/ProductUpdate.gql'
import graphql from '@/api/graphql'
import { AlertComponent as Alert } from 'vue-elder-alert'

export default {
  mixins: [
    ModelMixin({
      model: Model,
      guard: true,
      transform: {
        products: v => (v && v.length ? v.map(e => e.id) : null),
      },
    }),
  ],
  data() {
    return {
      products: [],
      promises: {
        submit: null,
        fetch: null,
      },
      data: null,
    }
  },
  computed: {
    breadcrumbs() {
      return [{ title: this.$metaInfo.title }]
    },
    disabledFields() {
      return this.$path('data.metadata.disabledFields')
    },
  },
  methods: {
    skip() {
      this.data = this.products.pop()
      this.moveOn()
    },
    fetch() {
      this.promises.fetch = graphql.request(Query, { id: this.id }).then(({ Products }) => {
        const products = Products.filter(
          product => product.internalId && (!product.images.length || !product.description || !product.supplier),
        )
        this.products = products
        this.data = this.products.pop()
      })
    },
    submit() {
      let { id, ...data } = this.getData()
      this.promises.submit = graphql.request(Mutate, { id, data }).then(() => {
        this.data = this.products.pop()
        this.moveOn()
      })
    },
    moveOn() {
      if (!this.data) {
        this.fetch()
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
    },
  },
  created() {
    this.fetch()
  },
  metaInfo() {
    return {
      title: 'Review produktimport',
    }
  },
  filters: {
    Moment,
  },
  components: {
    Alert,
    Card,
    FontAwesomeIcon,
    HeaderComponent,
    ProductForm,
  },
}
</script>

<style lang="scss">
.product-review {
  background-color: $background-grey;

  .header {
    margin: 0 auto;
    max-width: 1200px;
  }

  &__complete {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      height: 100%;
      width: 100% !important;
      opacity: 0.1;
      max-width: 800px;
      padding: 2rem;
    }
  }

  &__alert {
    background-color: transparent;
    font-size: 1em;
    margin: 0 auto 2rem auto;
    max-width: 75ch;
  }

  &__status {
    opacity: 0.5;
    font-style: italic;
    margin-top: 0.5rem;
    font-size: 0.7em;
  }

  &__footer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    .alert {
      width: 100%;
    }
  }

  &__buttons {
    display: flex;
    gap: 1rem;
    width: 100%;
    align-items: center;
    justify-content: flex-end;

    & > div {
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
